/**
 * Labstep
 *
 * @module screens/PurchaseOrder/Show/Right
 * @desc PurchaseOrder Show Right
 */

import { RightPane } from 'labstep-web/components/Layout/RightPane';
import { ThreadForm } from 'labstep-web/components/Thread/Form';
import { ICONS } from 'labstep-web/constants/icons';
import { LogIndex } from 'labstep-web/screens/Log/Index';
import type React from 'react';
import type { IScreensPurchaseOrderShowRightProps } from './types';

export const ScreensPurchaseOrderShowRight: React.FC<
  IScreensPurchaseOrderShowRightProps
> = ({ purchaseOrder }) => (
  <RightPane
    route={{
      to: 'purchase_order_show',
      params: { id: purchaseOrder.id },
    }}
    subPages={[
      {
        name: 'Notes',
        icon: ICONS.thread.primary,
        count: purchaseOrder.thread.comment_count,
        route: {
          to: 'purchase_order_show_thread',
          params: { id: purchaseOrder.id },
        },
        component: (
          <ThreadForm
            createThreadId={purchaseOrder.thread.id}
            readThreadIds={purchaseOrder.thread.id}
            entityNameLabel="notes"
          />
        ),
      },
      {
        name: 'Activity',
        icon: 'history',
        route: {
          to: 'purchase_order_show_activity',
          params: { id: purchaseOrder.id },
        },
        component: (
          <LogIndex
            entityName={purchaseOrder.entityName}
            entityId={purchaseOrder.id}
          />
        ),
      },
    ]}
  />
);
